import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip as ReTooltip } from 'recharts';

export const PriceHistoryModal = ({ priceHistoryFor, setPriceHistoryFor, priceHistoryData }) => (
  <Dialog open={!!priceHistoryFor} onOpenChange={() => setPriceHistoryFor(null)}>
    <DialogContent className="bg-[#0A0A0A] border-[#262626] max-w-2xl" data-testid="price-history-modal">
      <DialogHeader><DialogTitle className="font-serif text-white">{priceHistoryFor?.asset_name} — Price History</DialogTitle></DialogHeader>
      {priceHistoryData.length === 0 ? (
        <p className="text-xs text-muted-foreground italic text-center py-6">No price history yet. Trigger a re-valuation to start the timeline.</p>
      ) : (
        <div className="space-y-4">
          <div className="h-64">
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={priceHistoryData.map(p => ({
                date: new Date(p.captured_at).toLocaleDateString('en-GB', { day:'numeric', month:'short' }),
                price: p.price_per_fraction,
              }))} margin={{ top: 10, right: 10, bottom: 5, left: 0 }}>
                <XAxis dataKey="date" stroke="#444" tick={{ fill:'#999', fontSize:11 }} />
                <YAxis stroke="#444" tick={{ fill:'#999', fontSize:11 }} domain={[(min) => min * 0.95, (max) => max * 1.05]} tickFormatter={(v) => `£${v.toFixed(0)}`} />
                <ReTooltip contentStyle={{ background:'#0A0A0A', border:'1px solid #262626', fontSize:11 }} labelStyle={{ color:'#d4af37' }} itemStyle={{ color:'#fff' }} />
                <Line type="monotone" dataKey="price" stroke="#10B981" strokeWidth={2} dot={{ r: 3, fill: '#10B981' }} />
              </LineChart>
            </ResponsiveContainer>
          </div>
          <p className="text-[10px] text-muted-foreground italic">
            Price refreshed automatically every 7 days via AI valuation. Owner can also trigger a manual re-valuation from the My Listings tab.
          </p>
        </div>
      )}
    </DialogContent>
  </Dialog>
);
